<template>
  <div class="dashboard-container kuota">
    <div class="mb-2 page-title">
      <i class="bi bi-people-fill"></i> Ketersediaan Kelas
    </div>

    <p class="kuota__intro">Jumlah atlet terdaftar per kelas tanding dan nomor seni. Kelas yang penuh tidak bisa dipilih lagi.</p>

    <div class="kuota__atas">
      <div class="ui-field kuota__pilih">
        <label for="kuota-turnamen" class="ui-label">Turnamen</label>
        <select id="kuota-turnamen" v-model="turnamenId" class="form-control" @change="muat">
          <option value="">Pilih Turnamen</option>
          <option v-for="t in turnamenList" :key="t.id" :value="t.id">{{ t.name }}</option>
        </select>
      </div>
      <div v-if="turnamenId && !memuat && event" class="kk-event" :class="{ 'kk-event--penuh': event.penuh }">
        <div>
          <div class="kk-event__judul">Kuota atlet event</div>
          <div class="kk-event__angka">
            <strong>{{ event.terisi }}</strong>
            <span v-if="event.kuota"> / {{ event.kuota }} atlet</span>
            <span v-else> atlet terdaftar</span>
          </div>
        </div>
        <span v-if="!event.kuota" class="kk-chip">Tanpa batas</span>
        <span v-else-if="event.penuh" class="kk-chip kk-chip--penuh">Penuh · pendaftaran ditutup</span>
        <span v-else class="kk-chip" :class="event.sisa <= 10 ? 'kk-chip--hampir' : 'kk-chip--longgar'">Sisa {{ event.sisa }} atlet</span>
        <div v-if="event.kuota" class="kk-event__bar"><span :style="{ width: Math.min(100, Math.round(event.terisi / event.kuota * 100)) + '%' }"></span></div>
      </div>
    </div>

    <div v-if="memuat" class="kuota__pesan">
      <span class="spinner-border"></span> Menghitung keterisian kelas & nomor seni...
    </div>

    <template v-else-if="turnamenId">
      <!-- Pemberitahuan jika Panitia Tidak Mengizinkan Tampilan Kuota ke Official -->
      <div v-if="!diizinkanPanitia && !isPanitia" class="alert alert-warning d-flex align-items-center gap-3 p-3 my-3 rounded-3 shadow-sm">
        <i class="bi bi-eye-slash-fill fs-2 text-warning flex-shrink-0"></i>
        <div>
          <strong class="d-block">Tampilan Ketersediaan Kelas Dinonaktifkan oleh Panitia</strong>
          <span class="small text-secondary">
            Panitia/Admin turnamen ini memilih untuk tidak menampilkan rincian keterisian kelas. Pembatasan kuota tetap berjalan otomatis saat Anda mengisi formulir atlet (kelas yang penuh otomatis tidak dapat dipilih dan berwarna abu-abu).
          </span>
        </div>
      </div>

      <template v-else>
        <div class="kk-alat">
          <div class="kk-tab" role="tablist">
            <button v-for="j in ['semua', 'tanding', 'seni']" :key="j" type="button" role="tab"
                    :class="{ aktif: jenisAktif === j }" :aria-selected="jenisAktif === j" @click="jenisAktif = j">
              {{ j === 'semua' ? 'Semua' : j === 'tanding' ? 'Tanding' : 'Seni' }}
            </button>
          </div>
          <input v-model="cari" type="search" class="form-control kk-cari" placeholder="Cari kelas atau nomor…" aria-label="Cari kelas" />
        </div>
        <p class="kk-ket">
          {{ tersaring.length }} kelas/nomor ditampilkan<span v-if="ringkasan.penuh"> · <strong class="text-danger">{{ ringkasan.penuh }} penuh</strong></span>
        </p>

        <div v-for="(daftar, usia) in dikelompokkan" :key="usia" class="kk-grup">
          <h2 class="kk-grup__judul">{{ usia }}</h2>
          <div class="kk-dua">
            <div v-for="jk in ['male', 'female']" :key="jk" class="kk-kolom">
              <div class="kk-kolom__judul">{{ jk === 'female' ? 'Putri' : 'Putra' }}</div>
              <ul class="kk-daftar">
                <li v-for="k in daftar.filter((x) => (x.gender === 'female' ? 'female' : 'male') === jk)" :key="k.id" :class="{ 'kk-penuh': k.penuh }">
                  <div class="kk-nama">
                    <span class="kk-jenis" :class="`kk-jenis--${k.jenis}`">{{ k.jenis === 'tanding' ? 'Tanding' : 'Seni' }}</span>
                    <span>{{ k.jenis === 'seni' ? gantiTingkatUntuk(k.nama_kelas, turnamenId) : k.nama_kelas }}</span>
                    <span v-if="k.tingkat" class="kk-tingkat">{{ k.tingkat }}</span>
                    <small v-if="k.berat_min || k.berat_max" class="kk-redup">{{ Number(k.berat_min) }}–{{ Number(k.berat_max) }} kg</small>
                  </div>
                  <div class="kk-kanan">
                    <span class="kk-angka"><strong>{{ k.terisi }}</strong><span v-if="k.dibatasi">/{{ k.kuota }}</span> {{ k.is_team ? 'tim' : 'atlet' }}</span>
                    <span v-if="k.dibatasi" class="kk-chip" :class="`kk-chip--${nada(k)}`">{{ label(k) }}</span>
                  </div>
                </li>
                <li v-if="!daftar.some((x) => (x.gender === 'female' ? 'female' : 'male') === jk)" class="kk-kosong">Tidak ada kelas</li>
              </ul>
            </div>
          </div>
        </div>

        <p v-if="!tersaring.length" class="kuota__pesan">
          Tidak ada kelas yang cocok.
        </p>
      </template>
    </template>

    <p v-else class="kuota__pesan">Pilih turnamen untuk melihat keterisian kelas dan nomor seninya.</p>
  </div>
</template>

<script>
import { gantiTingkatUntuk, muatLabelTingkat } from '@/utils/tingkat';
import { useToast } from 'vue-toastification';
import http from '@/services/http';
import { hanyaTerlihat, pilihTurnamenOtomatis } from '@/utils/status';

export default {
  name: 'KetersediaanKelasPage',

  setup() {
    return { toast: useToast() };
  },

  data() {
    return {
      turnamenList: [],
      turnamenId: '',
      kelas: [],
      ringkasan: { total_kelas: 0, dibatasi: 0, penuh: 0 },
      event: null,
      diizinkanPanitia: true,
      cari: '',
      jenisAktif: 'semua',
      tampilSemua: true,
      memuat: false,
    };
  },

  computed: {
    isPanitia() {
      const role = localStorage.getItem('userRole') || '';
      return ['owner', 'admin', 'event pic'].some((r) => role.toLowerCase().includes(r));
    },

    tersaring() {
      const kata = this.cari.trim().toLowerCase();

      return this.kelas.filter((k) => {
        if (this.jenisAktif !== 'semua' && k.jenis !== this.jenisAktif) return false;
        if (!this.tampilSemua && !k.dibatasi && !k.terisi) return false;
        if (!kata) return true;
        return `${k.nama_kelas} ${k.kategori_usia} ${k.kategori_tanding}`.toLowerCase().includes(kata);
      });
    },

    /** Dikelompokkan per kategori usia — cara panitia dan pelatih berpikir. */
    dikelompokkan() {
      const wadah = this.tersaring.reduce((w, k) => {
        (w[k.kategori_usia] ||= []).push(k);
        return w;
      }, {});
      // Dalam satu usia: tanding dulu, lalu Putra semua, Putri semua, urut berat.
      Object.values(wadah).forEach((d) => d.sort((a, b) =>
        (a.jenis === 'tanding' ? 0 : 1) - (b.jenis === 'tanding' ? 0 : 1)
        || (a.gender === 'male' ? 0 : 1) - (b.gender === 'male' ? 0 : 1)
        || Number(a.berat_min ?? 0) - Number(b.berat_min ?? 0)));
      return wadah;
    },
  },

  mounted() {
    muatLabelTingkat();
    this.muatTurnamen();
  },

  methods: {
    gantiTingkatUntuk,
    hitungJenis(jenis) {
      return this.kelas.filter((k) => k.jenis === jenis).length;
    },

    infoBatasUsia(daftar) {
      if (!Array.isArray(daftar) || !daftar.length) return '';
      const pertama = daftar[0];
      const hasil = [];

      const batasT = pertama.kuota_tanding_kategori || daftar.find(k => k.jenis === 'tanding')?.kuota;
      const batasS = pertama.kuota_seni_kategori || daftar.find(k => k.jenis === 'seni')?.kuota;

      if (batasT) hasil.push(`Kuota Tanding: ${batasT} / kelas`);
      if (batasS) hasil.push(`Kuota Seni: ${batasS} / nomor`);

      return hasil.join('  •  ');
    },

    labelBatas(daftar) {
      return this.infoBatasUsia(daftar);
    },

    persen(k) {
      if (!k.kuota) return 0;
      return Math.min(100, Math.round((k.terisi / k.kuota) * 100));
    },

    /** Sisa dua kursi atau kurang dianggap kritis. */
    hampirPenuh(k) {
      return k.dibatasi && !k.penuh && k.sisa <= 2;
    },

    nada(k) {
      if (k.penuh) return 'penuh';
      if (this.hampirPenuh(k)) return 'hampir';
      return 'longgar';
    },

    label(k) {
      if (k.penuh) return 'Penuh';
      const unit = k.is_team ? 'tim' : 'slot';
      return `Sisa ${k.sisa} ${unit}`;
    },

    async muatTurnamen() {
      try {
        const { data } = await http.get('/tournaments', { params: { fetch_all: true } });
        const daftar = Array.isArray(data) ? data : data.data || [];
        this.turnamenList = hanyaTerlihat(daftar);

        this.turnamenId = pilihTurnamenOtomatis(this.turnamenList, this.$route.query);
        if (this.turnamenId) {
          this.muat();
        }
      } catch (e) {
        this.toast.error('Gagal memuat daftar turnamen.');
      }
    },

    async muat() {
      if (!this.turnamenId) {
        this.kelas = [];
        return;
      }

      this.memuat = true;
      try {
        const { data } = await http.get('/billings/kuota-kelas', {
          params: { tournament_id: this.turnamenId },
        });
        this.kelas = data.kelas || [];
        this.ringkasan = data.ringkasan || this.ringkasan;
        this.event = data.event || null;
        this.diizinkanPanitia = data.tampilkan_kuota_kelas !== undefined ? Boolean(data.tampilkan_kuota_kelas) : true;
      } catch (e) {
        this.kelas = [];
        this.toast.error(e?.response?.data?.message || 'Gagal memuat keterisian kelas.');
      } finally {
        this.memuat = false;
      }
    },
  },
};
</script>

<style scoped>
.kuota__atas { display: flex; flex-wrap: wrap; align-items: stretch; gap: .75rem; margin-bottom: .85rem; }
.kuota__pilih { flex: 1 1 260px; max-width: 380px; margin: 0; }
.kuota__atas .kk-event { flex: 1 1 260px; margin: 0 !important; padding: .5rem .85rem; }
.kk-event { display: flex; flex-wrap: wrap; align-items: center; justify-content: space-between; gap: .5rem .75rem; padding: .75rem 1rem; margin-bottom: 1rem; border: 1px solid var(--border-color, #e2e8f0); border-radius: 12px; background: var(--bg-surface, #fff); }
.kk-event--penuh { border-color: rgba(220,38,38,.45); }
.kk-event__judul { font-size: .75rem; color: var(--text-muted, #64748b); text-transform: uppercase; letter-spacing: .04em; }
.kk-event__angka { font-size: .95rem; }
.kk-event__angka strong { font-size: 1.25rem; }
.kk-event__bar { flex-basis: 100%; height: 6px; border-radius: 99px; background: var(--bg-sunken, #f1f5f9); overflow: hidden; }
.kk-event__bar span { display: block; height: 100%; background: #2563eb; }
.kk-event--penuh .kk-event__bar span { background: #dc2626; }
.kk-alat { display: flex; flex-wrap: wrap; gap: .75rem; align-items: center; margin-bottom: .5rem; }
.kk-tab { display: inline-flex; gap: 2px; padding: 3px; border-radius: 10px; background: var(--bg-sunken, #f1f5f9); }
.kk-tab button { border: 0; background: transparent; padding: 6px 14px; border-radius: 8px; font-weight: 600; font-size: .85rem; color: var(--text-secondary, #475569); }
.kk-tab button.aktif { background: var(--bg-surface, #fff); color: var(--text-primary, #0f172a); box-shadow: 0 1px 2px rgba(0,0,0,.08); }
.kk-cari { flex: 1 1 220px; max-width: 320px; }
.kk-semua { display: inline-flex; gap: .4rem; align-items: center; font-size: .85rem; margin: 0; }
.kk-ket { font-size: .8rem; color: var(--text-muted, #64748b); margin: 0 0 .6rem; }
.kk-grup { margin-bottom: .9rem; }
.kk-dua { display: grid; grid-template-columns: 1fr; gap: .75rem; }
@media (min-width: 768px) { .kk-dua { grid-template-columns: 1fr 1fr; } }
.kk-kolom { border: 1px solid var(--border-subtle, #e5e7eb); border-radius: 10px; overflow: hidden; background: var(--bg-surface, #fff); min-width: 0; }
.kk-kolom__judul { padding: .4rem .75rem; font-size: .75rem; font-weight: 700; text-transform: uppercase; letter-spacing: .04em; color: var(--text-secondary, #475569); background: var(--bg-sunken, #f8fafc); border-bottom: 1px solid var(--border-subtle, #eef0f3); }
.kk-daftar { list-style: none; margin: 0; padding: 0; font-size: .85rem; }
.kk-daftar li { display: flex; flex-wrap: nowrap; align-items: center; justify-content: space-between; gap: .35rem .75rem; padding: .38rem .7rem; border-bottom: 1px solid var(--border-subtle, #eef0f3); }
.kk-daftar li:last-child { border-bottom: 0; }
.kk-tingkat { font-size: .7rem; font-weight: 700; padding: 1px 7px; border-radius: 999px; background: var(--accent-subtle); color: var(--text-brand); white-space: nowrap; }
.kk-nama { display: flex; flex-wrap: wrap; align-items: center; gap: .25rem .4rem; min-width: 0; flex: 1 1 auto; }
.kk-kanan { display: flex; align-items: center; gap: .5rem; margin-left: auto; white-space: nowrap; }
.kk-kosong { color: var(--text-muted, #94a3b8); font-size: .8rem; justify-content: center !important; }
.kk-daftar li.kk-penuh { background: rgba(239, 68, 68, .07); }
.kk-grup__judul { font-size: .95rem; font-weight: 700; margin: 0 0 .4rem; }
.kk-tabel { width: 100%; border-collapse: collapse; font-size: .875rem; background: var(--bg-surface, #fff); border: 1px solid var(--border-subtle, #e5e7eb); border-radius: 10px; overflow: hidden; }
.kk-tabel td { padding: .55rem .75rem; border-bottom: 1px solid var(--border-subtle, #eef0f3); vertical-align: middle; }
.kk-tabel tr:last-child td { border-bottom: 0; }
.kk-penuh td { background: rgba(239, 68, 68, 0.08); }
.kk-jk { width: 80px; color: var(--text-secondary, #475569); }
.kk-angka { width: 110px; text-align: right; font-variant-numeric: tabular-nums; white-space: nowrap; }
.kk-status { width: 120px; text-align: right; }
.kk-redup { margin-left: .4rem; color: var(--text-muted, #94a3b8); }
.kk-jenis { display: inline-block; font-size: .65rem; font-weight: 700; text-transform: uppercase; padding: 1px 6px; border-radius: 999px; margin-right: .35rem; vertical-align: 1px; }
.kk-jenis--tanding { background: rgba(14, 165, 233, 0.15); color: #0284c7; }
.kk-jenis--seni { background: rgba(168, 85, 247, 0.15); color: #9333ea; }
.kk-chip { display: inline-block; font-size: .72rem; font-weight: 600; padding: 2px 8px; border-radius: 999px; background: var(--bg-sunken, #f1f5f9); color: var(--text-secondary, #475569); white-space: nowrap; }
.kk-chip--longgar { background: rgba(34, 197, 94, 0.15); color: #16a34a; }
.kk-chip--hampir { background: rgba(245, 158, 11, 0.18); color: #d97706; }
.kk-chip--penuh { background: rgba(239, 68, 68, 0.15); color: #dc2626; }
@media (max-width: 560px) { .kk-jk { width: auto; } .kk-status { width: auto; } }
/* ── Tabs Kategori ── */
.kategori-tabs {
  display: flex;
  gap: 0.5rem;
  overflow-x: auto;
  scrollbar-width: none;
  padding-bottom: 2px;
}
.kategori-tabs::-webkit-scrollbar { display: none; }

.tab-btn {
  display: inline-flex;
  align-items: center;
  padding: 0.45rem 1rem;
  font-size: var(--text-xs);
  font-weight: 600;
  border-radius: var(--radius-full);
  border: 1px solid var(--border-subtle);
  background: var(--bg-surface);
  color: var(--text-secondary);
  cursor: pointer;
  white-space: nowrap;
  transition: all var(--transition-fast);
}

.tab-btn:hover {
  background: var(--bg-sunken);
  color: var(--text-primary);
}

.tab-btn.active {
  background: var(--grad-flame, #f97316);
  color: #ffffff;
  border-color: transparent;
  box-shadow: 0 2px 6px rgba(249, 115, 22, 0.25);
}

.badge-tipe {
  display: inline-block;
  padding: 1px 6px;
  font-size: 0.6rem;
  font-weight: 800;
  letter-spacing: 0.5px;
  border-radius: var(--radius-sm);
  margin-right: 2px;
}
.badge-tipe--tanding {
  background: rgba(37, 99, 235, 0.12);
  color: #2563eb;
}
.badge-tipe--seni {
  background: rgba(168, 85, 247, 0.12);
  color: #9333ea;
}

[data-theme='dark'] .badge-tipe--tanding {
  background: rgba(59, 130, 246, 0.2);
  color: #60a5fa;
}
[data-theme='dark'] .badge-tipe--seni {
  background: rgba(168, 85, 247, 0.2);
  color: #c084fc;
}

.badge-tim {
  padding: 1px 6px;
  font-size: 0.62rem;
  font-weight: 700;
  color: var(--warning-600, #d97706);
  background: rgba(217, 119, 6, 0.12);
  border-radius: var(--radius-full);
}

.kuota__intro {
  font-size: var(--text-sm);
  line-height: 1.7;
  color: var(--text-secondary);
  margin-bottom: .75rem;
}

.kuota__pesan { padding: var(--space-8); text-align: center; color: var(--text-muted); }

/* ── Ringkasan ── */
.ringkas {
  display: grid;
  grid-template-columns: repeat(3, 1fr);
  gap: var(--space-3);
  margin-bottom: var(--space-5);
}

.ringkas__kotak {
  display: flex;
  flex-direction: column;
  gap: 2px;
  padding: var(--space-3);
  text-align: center;
  background: var(--bg-sunken);
  border: 1px solid var(--border-subtle);
  border-radius: var(--radius-lg);
}

.ringkas__kotak strong {
  font-family: var(--font-display);
  font-size: var(--text-2xl);
  color: var(--text-primary);
}

.ringkas__kotak span { font-size: var(--text-xs); color: var(--text-muted); }
.ringkas__kotak--penuh strong { color: var(--danger-600); }

/* ── Alat ── */
.kuota__alat {
  display: flex;
  flex-direction: column;
  gap: var(--space-3);
  margin-bottom: var(--space-5);
}

@media (min-width: 640px) {
  .kuota__alat { flex-direction: row; align-items: center; }
  .kuota__alat .form-control { max-width: 340px; }
}

.kuota__saring {
  display: inline-flex;
  align-items: center;
  gap: var(--space-2);
  font-size: var(--text-sm);
  color: var(--text-secondary);
  cursor: pointer;
  -webkit-user-select: none;
  user-select: none;
}

.kuota__saring * { color: inherit; }
.kuota__saring-teks { color: var(--text-secondary) !important; }
.kuota__saring input { width: 16px; height: 16px; accent-color: var(--accent); color: var(--text-secondary); }

/* ── Kelompok ── */
.kelompok { margin-bottom: var(--space-6); }

.kelompok__judul {
  display: flex;
  align-items: baseline;
  justify-content: space-between;
  gap: var(--space-3);
  margin: 0 0 var(--space-3);
  padding-bottom: var(--space-2);
  font-family: var(--font-display);
  font-size: var(--text-base);
  font-weight: 700;
  color: var(--text-primary);
  border-bottom: 1px solid var(--border-subtle);
}

.kelompok__batas {
  font-family: var(--font-sans);
  font-size: var(--text-xs);
  font-weight: 600;
  color: var(--text-muted);
  white-space: nowrap;
}

/* ── Kelas ── */
.kelas-daftar { list-style: none; margin: 0; padding: 0; display: grid; gap: var(--space-2); }

.kelas {
  display: flex;
  flex-direction: column;
  gap: var(--space-2);
  padding: var(--space-3);
  background: var(--bg-surface);
  border: 1px solid var(--border-subtle);
  border-left: 3px solid var(--border-strong);
  border-radius: var(--radius-md);
}

.kelas--hampir { border-left-color: var(--accent); }
.kelas--penuh  { border-left-color: var(--danger-600); background: var(--bg-sunken); }

@media (min-width: 640px) {
  .kelas { flex-direction: row; align-items: center; justify-content: space-between; }
}

.kelas__kiri { display: flex; flex-direction: column; gap: 2px; min-width: 0; }

.kelas__nama {
  display: flex;
  align-items: center;
  gap: var(--space-2);
  font-size: var(--text-sm);
  font-weight: 700;
  color: var(--text-primary);
  overflow-wrap: anywhere;
}

.kelas__gender {
  padding: 1px 6px;
  font-size: 0.62rem;
  font-weight: 700;
  color: var(--text-muted);
  background: var(--bg-sunken);
  border-radius: var(--radius-full);
}

.kelas__berat { font-size: var(--text-xs); color: var(--text-muted); }

.kelas__kanan {
  display: flex;
  align-items: center;
  gap: var(--space-3);
  flex-shrink: 0;
}

/* ── Bilah keterisian ── */
.bilah {
  width: 80px;
  height: 6px;
  background: var(--bg-sunken);
  border-radius: var(--radius-full);
  overflow: hidden;
}

.bilah__isi {
  height: 100%;
  background: var(--success-500);
  border-radius: var(--radius-full);
  transition: width var(--transition-base);
}

.kelas--hampir .bilah__isi { background: var(--accent); }
.kelas--penuh  .bilah__isi { background: var(--danger-600); }

.kelas__angka { font-size: var(--text-xs); color: var(--text-muted); white-space: nowrap; }
.kelas__angka strong { font-size: var(--text-sm); color: var(--text-primary); }

.kelas__status {
  padding: 2px var(--space-2);
  font-size: 0.65rem;
  font-weight: 700;
  white-space: nowrap;
  border-radius: var(--radius-full);
}

.kelas__status--longgar { color: var(--success-600); background: rgb(22 163 74 / 0.12); }
.kelas__status--hampir  { color: var(--text-brand); background: var(--accent-subtle); }
.kelas__status--penuh   { color: var(--danger-600); background: rgb(220 38 38 / 0.12); }
.kelas__status--bebas   { color: var(--text-muted); background: var(--bg-sunken); }

@media (prefers-reduced-motion: reduce) { .bilah__isi { transition: none; } }
</style>
